import { Entity, Icon, Insight, InsightID } from "../types/data";

export const ENTITIES: Entity[] = [
  "friends",
  "public",
  "instagram",
  "facebook",
  "amazon",
  "spotify",
  "reddit",
  "google",
  "youtube",
  "twitter",
  "pinterest",
  "linkedin",
];

export const entityIcon = (e: Entity): Icon => {
  const map: { [key in Entity]: Icon } = {
    friends: "user-friends",
    public: "globe-europe",
    instagram: "instagram",
    facebook: "facebook",
    amazon: "amazon",
    spotify: "spotify",
    reddit: "reddit",
    google: "google",
    youtube: "youtube",
    twitter: "twitter",
    pinterest: "pinterest",
    linkedin: "linkedin",
  };

  return map[e];
};

export const calculateStories = (insights: Insight[]) =>
  ENTITIES.map((entity) => {
    let entityStories: InsightID[] = [];

    insights.forEach((insight) => {
      const data = insight.visibilities.find((v) => v.entity === entity)?.data;

      if (!data) return;
      const x1 = data[data.length - 2];
      const x2 = data[data.length - 1];

      if (Math.abs(x1 - x2) > 35) entityStories.push(insight.id);
    });

    return { entity, insights: entityStories, viewed: false };
  }).filter((s) => s.insights.length !== 0);
